<template>
  <div class="toast-body text-break" v-text="message" />
</template>

<script>
export default {
  name: "ToastBody",
  props: {
    message: {
      type: String,
      required: true,
    },
  }
}
</script>
